import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

import { SERVER_URL } from '../../config';
import { formatDate } from '../../utils/date'

import { updateMobileMainHeaderColor } from '../../services/scrollService';
import { animationController, removeMainTransClass } from '../../services/mainService';
import { fetchCertData } from '../../services/certService'
import { fetchGalleryListData, fetchGalleryDetailData } from '../../services/portfolioService'
import { fetchNoticeListData } from '../../services/noticeService'

import { mbSwiperSlides, prdCards as initialPrdCards, circleBorderCards, circleCards, fieldCards } from './MobileMainData';

import { mbMainTopBack , mainProduct, prdWhite1, prdBlack1, prdWhite2, prdBlack2, prdWhite3, prdBlack3, prdWhite4, prdBlack4, prdReader, prdTag, prdIcCard, prdPrinter } from '../../assets/images/main/mainImages';

import './MainPage.css';

import MobileMainSwiper from '../../components/Swiper/MobileMainSwiper';
import MainProductCard from '../../components/Card/MainProductCard';
import MainImageCard from '../../components/Card/MainImageCard';
import MainFieldCard from '../../components/Card/MainFieldCard';
import MainCircleCard from '../../components/Card/MainCircleCard';
import Map from '../../components/Map/Map';
import BorderBottomList from '../../components/List/BorderBottomList';
import Footer from '../../components/Footer/Footer';
import DetailModal from '../../components/Modal/DetailModal';


const MobileMainPage = () => {

  const [cert, setCert] = useState([]);
  const [portfolio, setPortfolio] = useState([]);
  const [notice, setNotice] = useState([]);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [dgDetailData, setDgDetailData] = useState();
  const [prdImgIdx, setPrdImgIdx] = useState(0);
  const [prdCards, setPrdCards] = useState(initialPrdCards);
  const prdMainImages = [prdReader, prdTag, prdIcCard, prdPrinter]
  const prdWhiteImages = [prdWhite1, prdWhite2, prdWhite3, prdWhite4];
  const prdBlackImages = [prdBlack1, prdBlack2, prdBlack3, prdBlack4];
  
  const outerDivRef = useRef();

  useEffect(() => {
    const certListData = async () => {
      const certData = await fetchCertData(4);
      setCert(certData);
    };

    const portfolioListData = async () => {
      const pfData = await fetchGalleryListData(4, null);
      setPortfolio(pfData.dgList);
    };

    const noticeListData = async () => {
      const ntData = await fetchNoticeListData(4, null, null, null);
      setNotice(ntData.ntList);
    };

    certListData();
    portfolioListData();
    noticeListData();
  }, []);

  const openDetailModal = async (idx) => {
    const galleryDetailData = await fetchGalleryDetailData(idx);
    setDgDetailData(galleryDetailData);
    setIsDetailModalOpen(true);
  };

  const closeDetailModal = () => {
    setIsDetailModalOpen(false);
    setDgDetailData(null);
  };
  
  const [sectionVisibility, setSectionVisibility] = useState([false, false, false, false, false, false, false, false]);
  const sectionRefs = useRef([]);

  useEffect(() => {

    const options = {
      threshold: 0.5,
    };

    const headerOptions = {
      threshold: 0.7,
    };

    const section1Options = {
      threshold: 0.3,
    };
    const section5Options = {
      threshold: 0.1,
    };
    
    const callbackEvent = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const index = Number(entry.target.dataset.index);
          setSectionVisibility(prevVisibility => {
            const updatedVisibility = [...prevVisibility];
            updatedVisibility[index] = entry.isIntersecting;
            return updatedVisibility;
          });
        } else {
          const index = Number(entry.target.dataset.index);
          setSectionVisibility(prevVisibility => {
            const updatedVisibility = [...prevVisibility];
            updatedVisibility[index] = false;
            return updatedVisibility;
          });
        }
      });
    };

    const callbackHeader = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const index = Number(entry.target.dataset.index);
          if(index !== 1 && index !== 5) {
            updateMobileMainHeaderColor(index);
          }
        }
      });
    };

    const callbackSection1 = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const index = Number(entry.target.dataset.index);
          if(index === 1) {
            animationController(1, 'M');
            updateMobileMainHeaderColor(1);
          }
        }
      });
    };
    
    const callbackSection5 = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const index = Number(entry.target.dataset.index);
          if(index === 5) {
            animationController(5, 'M');
            updateMobileMainHeaderColor(5);
          }
        }
      });
    };

    const observer = new IntersectionObserver(callbackEvent, options);
    const headerObserver = new IntersectionObserver(callbackHeader, headerOptions);
    const section1Observer = new IntersectionObserver(callbackSection1, section1Options);
    const section5Observer = new IntersectionObserver(callbackSection5, section1Options);

    sectionRefs.current.forEach((sectionRef, index) => {
      if (sectionRef) {
        observer.observe(sectionRef);
        headerObserver.observe(sectionRef);
        section1Observer.observe(sectionRef);
        section5Observer.observe(sectionRef);
      }
    });

    return () => {
      sectionRefs.current.forEach((sectionRef) => {
        if (sectionRef) {
          observer.unobserve(sectionRef);
          headerObserver.unobserve(sectionRef);
          section1Observer.unobserve(sectionRef);
          section5Observer.unobserve(sectionRef);
        }
      });
    };
  }, []);

  
  useEffect(() => {
    removeMainTransClass();
    sectionVisibility.forEach((isVisible, index) => {
      if (isVisible) {
        switch (index) {
          case 1:
            animationController(1, 'M');
            break;
          case 2:
            animationController(2, 'M');
            break;
          case 3:
            animationController(3, 'M');
            break;
          case 4:
            animationController(4, 'M');
            break;
          case 5:
            animationController(5, 'M');
            break;
          case 6:
            animationController(6, 'M');
            break;
          case 7:
            animationController(7, 'M');
            break;
        }
      }
    });
  }, [sectionVisibility]);

  const handlePrdImg = async (prdImgidx) => {
    setPrdImgIdx(prdImgidx);
    setPrdCards(prevCards => {
      const updatedCards = prevCards.map((card, index) => {
        const newWrapClass = card.wrapClass.split(' ').map(cls => {
          if (cls === 'prd-card-div1' || cls === 'prd-card-div2') {
            return (index === prdImgidx ? 'prd-card-div1' : 'prd-card-div2');
          }
          return cls;
        }).join(' ');
        
        return {
          ...card,
          imgPath: index === prdImgidx ? prdWhiteImages[index] : prdBlackImages[index],
          wrapClass: newWrapClass + (newWrapClass.includes('show') ? '' : ' show'),
        };
      });
      return updatedCards;
    });
  };

  const handlePrdMainImg = (index) => {
    return (
      <div id='prdImgDiv'>
        <img src={prdMainImages[index]} alt='제품이미지' id='main-prd-intro-img' className='main-trans-b-t show' />
      </div>
    );
  }

  const slides = [
    {
      content: (
        <div id='section-0' className='main-section-con' ref={el => (sectionRefs.current[0] = el)} data-index={0}>
          <div className='block-div'></div>
          <img id='main-back-img' src={mbMainTopBack} />
          <div className=''>
            <MobileMainSwiper slides={mbSwiperSlides} />
          </div>
        </div>
      ),
    },
    {
      content: (
        <div id='section-1 prd-main-section-con' className='bg-white' ref={el => (sectionRefs.current[1] = el)} data-index={1}>
          {/* <div className='block-div'></div> */}
          <div className='prd-flex-div'>
            <div id='main-prd-intro'>
              <div className='main-center-title'>Product</div>
              <p id='main-prd-intro-content' className='main-trans-b-t'>엠포플러스(주)는<br/>
                다양한 기업의 비즈니스 니즈를 해결하기 위한<br/>
                제품을 소개합니다.
              </p>
            </div>
            <div id='product-card-wrap' className=''>
              {prdCards.map((prdCard, index) => (
                <>
                  {prdImgIdx === index ? handlePrdMainImg(index) : ''}
                  <Link onClick={() => handlePrdImg(index)} className='text-line-none' to={prdCard.linkUrl}>
                    <MainProductCard key={index} cardId={`prd-card-${index}`} prdCards={prdCards[index]} />
                  </Link>
                </>
              ))}
            </div>
          </div>
        </div>
      ),
    },
    {
      content: (
        <div id='section-2' className='main-section-con' ref={el => (sectionRefs.current[2] = el)} data-index={2}>
          {/* <div className='block-div'></div> */}
          <div className=''>
            <div className='sol-main-center-title'>Solution</div>
            <div className='sol-main-center-content'>
              고객님들의 편의를 위한 다양한 <br />솔루션을 제공합니다.
            </div>
            <div id='sol-circle-wrap'>
              {circleBorderCards.map((circleBorderCard, index) => (
                <div id={`sol-circle-card-${index}`} key={index}>
                  <Link to={circleBorderCard.url} className='text-line-none'>
                    <div className='sol-mb-card-img-div flex-row center '>
                      <div>
                        <img src={circleBorderCard.imgPath}/>
                      </div>
                    </div>
                    <div className='sol-mb-card-text'>
                      {circleBorderCard.content}
                    </div>
                    <div className='sol-mb-card-line-div'></div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      ),
    },
    {
      content: (
        <div id='section-3' className='main-section-con bg-white' ref={el => (sectionRefs.current[3] = el)} data-index={3}>
          <div className='flex-div'>
            <div className='main-center-title'>Certification</div>
            <div className='main-center-content'>
              RFEMFO 의 인증현황 입니다.
            </div>
            <div id='cert-card-wrap'>
              {cert.map((item, index) => (
                <MainImageCard 
                  key={index} 
                  imgPath={SERVER_URL + item.CT_THUMBNAIL_PATH}
                  title={item.CT_TITLE}
                  cardId={`main-cert-card-${index}`}
                  wrapClass={'main-trans-b-t cert-card-div'}
                  imgClass={'cert-card-img'}
                  titleClass={'cert-card-title'}
                />
              ))}
            </div>
            <div id='main-cert-more-btn' className='main-more-btn main-trans-b-t'>
              <Link className='text-line-none' to={'/company/certList'}>
                + 더보기
              </Link>
            </div>
          </div>
        </div>
      ),
    },
    {
      content: (
        <div id='section-4' className='main-section-con bg-white' ref={el => (sectionRefs.current[4] = el)} data-index={4}>
          <div className='flex-div'>
            <div className='main-center-title'>Portfolio</div>
            <div className='main-center-content'>
              RFEMFO 납품갤러리 입니다.
            </div>
            <div id='cert-card-wrap'>
              {portfolio ? portfolio.map((item, index) => (
                <div key={index+4} onClick={() => openDetailModal(item.DG_IDX)} id={`main-pf-card-${index}`} className='cert-card-div main-trans-b-t'>
                  <MainImageCard 
                    key={index} 
                    imgPath={SERVER_URL + item.DG_THUMBNAIL}
                    title={item.DG_TITLE}
                    cardId={`main-pf-card-${index}`}
                    wrapClass={'pf-card-div'}
                    imgClass={'cert-card-img'}
                    titleClass={'cert-card-title'}
                  />
                </div>
              )) : ''}
            </div>
            {isDetailModalOpen && (
              <DetailModal isOpen={isDetailModalOpen} onClose={closeDetailModal} data={dgDetailData} imgUrl={SERVER_URL}/>
            )}
            <div id='main-pf-more-btn' className='main-more-btn main-trans-b-t'>
              <Link className='text-line-none ' to={'/portfolio/delivery/1'}>
                + 더보기 
              </Link>
            </div>
          </div>
        </div>
      ),
    },
    {
      content: (
        <div id='section-5' className='main-section-con bg-white' ref={el => (sectionRefs.current[5] = el)} data-index={5}>
          {/* <div className='block-div'></div> */}
          <div className='prd-flex-div'>
            <div className='main-center-title'>RFID / NFC 활용분야</div>
            <div id='circle-box-wrap'>
              {circleCards.map((circleCard, index) => (
                <MainCircleCard 
                  key={index} 
                  circleCards={circleCards[index]} 
                />
              ))}
            </div>
            <div id='field-card-wrap'>
              {fieldCards.map((fieldCard, index) => (
                <MainFieldCard 
                  key={index} 
                  fieldCards={fieldCards[index]} />
              ))}
            </div>
          </div>
        </div>
      ),
    },
    {
      content: (
        <div id='section-6' className='main-section-con bg-white' ref={el => (sectionRefs.current[6] = el)} data-index={6}>
          {/* <div className='block-div'></div> */}
          <div className='main-center-title'>Notice</div>
          <div id='notice-list-wrap'>
            {notice ? notice.map((item, index) => (
              <BorderBottomList 
                key={index}
                keyprop={item.NT_IDX}
                date={formatDate(item.NT_INPUT_DATE)}
                title={item.NT_TITLE}
                divId={`main-nt-div-${index}`}
                wrapClass={'main-trans-b-t'}
                url={`/support/notice/detail/${item.NT_IDX}`}
              /> 
            )) : ''}
          </div>
          <div id='main-nt-more-btn' className='main-more-btn main-trans-b-t'>
            <Link className='text-line-none' to={'/support/notice/1'}>
              + 더보기
            </Link>
          </div>
        </div>
      ),
    },
    {
      content: (
        <div id='section-7' className='main-section-con bg-white' >
          {/* <div className='block-div'></div> */}
          <div id='contact-wrap'>
              <div id='map-div'>
            <Link to={'/company/way'}>
                <Map />
            </Link>
              </div>
            <div id='contact-div' ref={el => (sectionRefs.current[7] = el)} data-index={7}>
              <div id='main-cont-div-0' className='main-trans-b-t'>
                <div className='sol-main-center-title'>Contact us</div>
                <div className='section-7-content'>EMFOPLUS are always welcome</div>
              </div>
              <div id='main-cont-div-1' className='main-trans-b-t'>
                <div className='contact-sub-title'>Add</div>
                <div className='section-7-content'>서울시 성동구 아차산로 17길 48<br />
                SK V1센터 1동 1615-1620호<br /><br />
                48, Achasan-ro 17-gil, Seongdong-gu, Seoul,<br />
                Republic of Korea</div>
              </div>
              <div id='main-cont-div-2' className='main-trans-b-t'>
                <div className='contact-sub-title'>Tel</div>
                <div className='section-7-content'>TEL. 1599-2320 <br />
                E-MAIL. rfid@emfoplus.co.kr</div>
              </div>
            </div>
          </div>
        </div>
      ),
    },
  ];

  

  return (
    <div ref={outerDivRef} className="outer">
      {slides.map((slide, index) => (
        <div className='main-section-content' key={index}>
          {slide.content}
        </div>
      ))}
      <Footer id='main-menu-8' />
    </div>
  );
};

export default MobileMainPage;
